export { default } from './Accordion';



// WEBPACK FOOTER //
// ./src/client/js/view/components/Accordion/index.js